// extracted by mini-css-extract-plugin
module.exports = {"wrap":"fk-z","heading":"gk-z","items":"hk-z","featureCss":"ik-z","disabled":"jk-z","imgCss":"kk-z"};